<template>
  <div class="navBar">
    <div v-if="showHolder" class="holder" @click="onHolderClick">
      <span>{{ selected }}</span>
      <span class="icon"></span>
    </div>
    <div v-if="showHolder" v-show="showHolderDropDown" class="holder-dropdown">
      <van-popup
        v-model="showPopup"
        class="with-holder"
        position="top"
        overlay-class="with-holder"
        :overlay="overlay"
        :duration="0.6"
        @closed="onPopupClosed"
      >
        <ul>
          <li v-for="(item, index) in navBarLink" :key="index" v-show="item.show">
            <a :href="item.to" @click.stop.prevent="handleMenuClick(item)">{{ item.label }}</a>
          </li>
        </ul>
      </van-popup>
    </div>
    <van-popup
      v-else
      v-model="showPopup"
      position="top"
      :overlay="true"
      :duration="0.6"
      @closed="$emit('afterPopupClosed')"
    >
      <ul>
        <li v-for="(item, index) in navBarLink" :key="index" v-show="item.show">
          <a :href="item.to" @click.stop.prevent="handleMenuClick(item)">{{ item.label }}</a>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import { deviceType } from '@/utils/common'
import personalRoute from '@/views/personal/route'
import * as referralsRoute from '@/views/personal/referralsRoute'
import homeRoute from '@/views/personal/homeRoute'
import surveyRoute from '@/views/survey/route'

export default {
  props: {
    account: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    showNavBar: {
      type: Boolean,
      required: true
    },
    job: {
      type: Object,
      default: null
    },
    isHiddenHome: {
      type: Boolean,
      default: false
    },
    currentPage: {
      type: Number,
      required: true
    },
    showHolder: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showPopup: false,
      showHolderDropDown: false,
      overlay: true,
      selected: ''
    }
  },
  computed: {
    rootCompanyId () {
      if (this.company.root_company) {
        return this.company.root_company.id
      } else {
        return this.company.id
      }
      // return this.company.root_company ? this.company.root_company.id : this.company.id
    },
    hasRootCompanyId () {
      const rootCompany = this.company && this.company.root_company
      if (rootCompany && rootCompany.id) {
        return this.company.id !== rootCompany.id
      }
      return false
    },
    navBarLink () {
      const settings = {
        parentCompanyDetail: {
          show: false, // no add if block, because old js will hide all options
          to: `/recruiting/company/${this.rootCompanyId}/branding`,
          label: this.$t('navBar.parentCompanyDetail'),
          isInclude: true
        },
        parentCompanyJobList: {
          show: false, // no add if block, because old js will hide all options
          to: `/mobile-web-more-jobs/${this.rootCompanyId}`,
          label: this.$t('navBar.parentCompanyJobList'),
          isInclude: true
        },
        companyDetail: {
          show: false,
          to: `/recruiting/company/${this.company.id}/branding`,
          label: this.$t('navBar.companyDetail'),
          isInclude: true
        },
        companyJobList: {
          show: false,
          to: this.$DjangoBaseUrl(`/mobile-web-more-jobs/${this.company.id}`),
          label: this.$t('navBar.companyJobList'),
          isInclude: true
        },
        earningsAndReferrals: {
          show: false,
          to: referralsRoute.rewardsRoute.path,
          label: this.$t('navBar.myReward'),
          isInclude: true
        },
        myRedeem: {
          show: false,
          to: '#',
          label: this.$t('navBar.myRedeem')
        },
        personalInformation: {
          show: false,
          to: homeRoute.path,
          label: this.$t('navBar.personalInfo'),
          isInclude: true
        },
        // aboutProgram: {
        //   show: false, // no add if block, because old js will hide all options
        //   to: this.$DjangoBaseUrl('/referral/about-program/'),
        //   label: this.$t('navBar.aboutPlan')
        // },
        jobDescription: {
          show: false,
          to: '#',
          label: this.$t('navBar.jobDescription')
        },
        myPreference: {
          show: false,
          to: '#', // will auto replace with survey path(like '/recruiting/company/64/survey')
          label: this.$t('navBar.myPreference'),
          isInclude: true
        },
        logout: {
          show: false,
          // TODO remove and clear vue store/account state.currentAccount
          to: this.$DjangoBaseUrl('/logout/'),
          label: this.$t('navBar.logout')
        }
      }
      this.initLink(settings)
      return settings
    }
  },
  created () {
    if (this.showHolder) {
      this.showPopup = false
      switch (this.currentPage) {
        case 1:
          this.selected = this.navBarLink.companyJobList.label
          break
        case 6:
          this.selected = this.navBarLink.jobDescription.label
          this.overlay = false
          break
      }
    } else {
      this.showPopup = this.showNavBar
    }
  },
  methods: {
    showEmployeeNavi (settings) {
      settings.companyJobList.show = true
      settings.earningsAndReferrals.show = true
      settings.personalInformation.show = true
      settings.aboutProgram.show = true
      settings.logout.show = true
      const employee = this.account.employee
      if (employee.status === '2' || employee.status === 2) {
        const companyId = employee.company.id
        settings.myPreference.to = surveyRoute.path.replace(/:companyId/g, companyId)
        settings.myPreference.show = true

        const rootCompanyId = this.getEmployeeRootCompanyId(employee)
        if (rootCompanyId === 7908) {
          settings.aboutProgram.show = false
          settings.earningsAndReferrals.show = false
        }
      }
    },
    showExternalNavi (settings) {
      settings.earningsAndReferrals.show = true
      settings.personalInformation.show = true
      settings.aboutProgram.show = true
      settings.logout.show = true
    },
    notShowReferralNavi (settings) {
      settings.earningsAndReferrals.show = false
      settings.aboutProgram.show = false
    },
    getEmployeeRootCompanyId (employee) {
      const company = employee.company
      if (company.root_company) {
        return company.root_company.id
      } else {
        return company.id
      }
    },
    initLink (settings) {
      // var $companyJobList = 1
      // var $earningReferral = 2
      // var $personalInfo = 4
      // var $aboutProgram = 5
      // var $companyDetail = 7
      // var $rootCompanyDetail = 10
      // var $rootCompanyJobList = 11
      // var $logout = 8
      const currentPage = this.currentPage
      if (currentPage === 3) {
        return
      }
      if (this.account && this.account.id) {
        if (this.account.employee) {
          if (currentPage === 1 || currentPage === 6) {
            settings.companyDetail.show = true
            if (this.hasRootCompanyId) {
              settings.parentCompanyDetail.show = true
              settings.parentCompanyJobList.show = true
            }
          } else if (currentPage === 5) {
            settings.companyDetail.show = true
          } else if (currentPage === 7) {
            if (this.hasRootCompanyId) {
              settings.parentCompanyDetail.show = true
              settings.parentCompanyJobList.show = true
            }
          }
          this.showEmployeeNavi(settings)
        } else {
          switch (currentPage) {
            case 1:
              settings.companyDetail.show = true
              if (this.hasRootCompanyId) {
                settings.parentCompanyDetail.show = true
                settings.parentCompanyJobList.show = true
              }
              // TODO: recheck
              // this code unknown
              if (this.company && this.company.id) {
                sessionStorage.setItem('visited_company_id', this.company.id)
              }
              break
            case 5:
              // TODO: recheck
              // this code unknown
              if (sessionStorage.getItem('visited_company_id')) { // TODO
                settings.companyJobList.show = true
                settings.companyDetail.show = true
                if (this.hasRootCompanyId) {
                  settings.parentCompanyDetail.show = true
                  settings.parentCompanyJobList.show = true
                }
                // TODO: recheck
                // this code unknown
                // $('#nav_company_id').val(sessionStorage.getItem('visited_company_id'))
              }
              break
            case 6:
              settings.companyJobList.show = true
              settings.companyDetail.show = true
              if (this.hasRootCompanyId) {
                settings.parentCompanyDetail.show = true
                settings.parentCompanyJobList.show = true
              }

              // TODO: recheck
              // this code unknown
              if (this.company && this.company.id) {
                sessionStorage.setItem('visited_company_id', this.company.id)
              }
              break
            case 7:
              settings.companyJobList.show = true
              if (this.hasRootCompanyId) {
                settings.parentCompanyDetail.show = true
                settings.parentCompanyJobList.show = true
              }
              if (this.company && this.company.id) {
                sessionStorage.setItem('visited_company_id', this.company.id)
              }
              break
            default:
              break
          }
          this.showExternalNavi(settings)
        }
      } else {
        switch (currentPage) {
          case 1:
            settings.companyDetail.show = true
            if (this.hasRootCompanyId) {
              settings.parentCompanyDetail.show = true
              settings.parentCompanyJobList.show = true
            }

            // TODO: recheck
            // this code unknown
            if (this.company && this.company.id) {
              sessionStorage.setItem('visited_company_id', this.company.id)
            }
            break
          case 2:
            settings.companyDetail.show = true
            break
          case 5:
            if (sessionStorage.getItem('visited_company_id')) { // TODO
              settings.companyDetail.show = true
              settings.companyJobList.show = true

              // TODO: recheck
              // this code unknown
              // $('#nav_company_id').val(sessionStorage.getItem('visited_company_id'))
            }
            break
          case 6:
            settings.companyDetail.show = true
            settings.companyJobList.show = true
            if (this.hasRootCompanyId) {
              settings.parentCompanyDetail.show = true
              settings.parentCompanyJobList.show = true
            }

            // TODO: recheck
            // this code unknown
            if (this.company && this.company.id) {
              sessionStorage.setItem('visited_company_id', this.company.id)
            }
            break
          case 7:
            settings.companyJobList.show = true
            if (this.hasRootCompanyId) {
              settings.parentCompanyDetail.show = true
              settings.parentCompanyJobList.show = true
            }
            if (this.company && this.company.id) {
              sessionStorage.setItem('visited_company_id', this.company.id)
            }
            break
          default:
            break
        }
      }
      if (this.isHiddenHome) {
        if (this.hideReferralFlag) {
          this.notShowReferralNavi(settings)
        }
      }
      if ((this.company && this.company.is_referral_enabled) ||
        (this.job && this.job.company && this.job.company.is_referral_enabled)) {
        this.notShowReferralNavi(settings)
      }
    },
    onHolderClick () {
      this.showPopup = !this.showPopup
      if (this.showPopup) {
        this.showHolderDropDown = true
      }
    },
    onPopupClosed () {
      this.showHolderDropDown = false
      this.$emit('afterPopupClosed')
    },
    handleMenuClick (menuItem) {
      const path = menuItem.to
      if (menuItem.isInclude) {
        const routeInfo = { path }
        if (path.startsWith(personalRoute.path) && !deviceType.isPc) {
          routeInfo.query = { company_id: this.company.id }
        }
        this.$router.push(routeInfo)
      } else {
        location.href = path
      }
    }
  },
  watch: {
    showNavBar (value) {
      if (this.showHolder) {
        return
      }
      this.showPopup = value
    }
  }
}
</script>

<style lang="scss" scoped>
.navBar {
  .holder {
    display: inline-block;
    overflow: hidden;
    text-indent: 20px;
    margin-bottom: 2px;
    width: 100%;
    color: #fff;
    line-height: 45px;

    .icon {
      width: 12px;
      background-image: url($baseDomain + 'static/image/mobile_web/icon_dropdown.png');
      height: 7px;
      background-size: 100% 100%;
      margin-left: 10px;
      display: inline-block;
    }
  }

  .holder-dropdown {
    position: fixed;
    top: 47px;
    z-index: 200;
    right: 0;
    left: 0;
    bottom: 0;
    overflow: hidden;

    ::v-deep .with-holder {
      position: absolute;
    }
  }

  .van-popup.van-popup--top, .van-dropdown-menu {
    background: #282b2e;
    text-indent: 20px;

    li {
      width: 100%;
      border-bottom: 1px solid #030303;

      a {
        width: 100%;
        display: block;
        text-indent: 0px;
        height: 45px;
        line-height: 45px;

        &:link {
          color: #fff;
          text-decoration: none;
        }

        &:visited {
          color: #fff;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
